import React, { lazy, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BookingNotification from './components/BookingNotification';
import './App.css';

// Lazy load HomePage to improve initial loading
const HomePage = lazy(() => import('./pages/HomePage'));

// Simple loading component
const Loading = () => (
  <div className="min-h-screen bg-gradient-to-br from-temple-50 to-gold-50 flex items-center justify-center">
    <div className="text-xl font-medium text-temple-800">กำลังโหลด...</div>
  </div>
);

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-temple-50 to-gold-50 font-thai">
        <Suspense fallback={<Loading />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
          </Routes>
        </Suspense>
        <BookingNotification />
      </div>
    </Router>
  );
}

export default App;